import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/password.svg';
import PropTypes from 'prop-types';
import LogoutStyled from '../shared/LogoutStyled';
import MoreOptions from '../shared/MoreOptions';

import * as actions from '../../actions';

/**
 * PasswordPage Component
 */
export class PasswordPage extends Component {
  /**
   * The allowed properties for the PasswordPage component
   * @param {function} verifyPassword verification the user's password
   * @param {bool} isLoading is something on the page loading?
   * @param {array} availableModalities available modalities to switch to
   */
  static propTypes = {
    verifyPassword: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
    unknownUserForWebSso: PropTypes.bool,
    errorMessage: PropTypes.array,
  };

  static defaultProps = {
    availableModalities: [],
    authenticatedModalities: [],
    useCustomUX: false,
  };

  submit = state => {
    if (!state || !state.tokenCode || state.tokenCode.trim() === '') {
      return;
    }
    this.props.verifyPassword(state.tokenCode);
  };

  render() {
    const {
      availableModalities,
      errorMessage,
      isLoading,
      sessionService,
      username,
      useCustomUX,
      allowEditUsername,
      isClinicalWorkflow,
      unknownUserForWebSso,
    } = this.props;

    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'password' && e !== 'tempcode') : [];
    const moreOptions = (modalities.length > 0 && !unknownUserForWebSso) ? <MoreOptions currentModality='password' /> : null;
    const isCidMobile = (sessionService === 'cidmobile');
    const headerDescription = isCidMobile ? username : null;
    const submitText = !isClinicalWorkflow ? 'Continue' : 'Confirm your identity';
    const logoutStyle = useCustomUX ? 'black' : 'white';
    const logoutComponent = isCidMobile ? null : <LogoutStyled type={logoutStyle} />;
    // Workaround for this issue https://github.com/text-mask/text-mask/issues/806
    const anyCharMask = (value) => Array(value.length).fill(/./);

    return (
      <div className='content-body'>
        <SingleInput
          inputMask={anyCharMask}
          isLoading={isLoading}
          headerImage={headerImage}
          headerTitle='Enter password'
          headerDescription={headerDescription}
          placeholderText='Password'
          submitText={submitText}
          onSubmit={this.submit}
          retryText=''
          moreOptionsLink={moreOptions}
          autoFocus={true}
          displayErrors={errorMessage}
          logoutComponent={logoutComponent}
          cidMobile={isCidMobile}
          useCustomUX={useCustomUX}
          username={isCidMobile ? null : username}
          allowEditUsername={allowEditUsername}
          resetUsername={this.props.reset}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    isLoading, availableModalities, serverState, sessionService, errorCode, errorMessage,
    useCustomUX, username, isClinicalWorkflow, allowEditUsername, unknownUserForWebSso,
  } = state.login;
  return {
    isLoading,
    availableModalities,
    serverState,
    sessionService,
    errorCode,
    errorMessage,
    username,
    useCustomUX,
    allowEditUsername,
    isClinicalWorkflow,
    unknownUserForWebSso,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifyPassword: password => {
      dispatch(actions.verifyPassword(password) );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordPage);
